import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyAu-QWBmlQkkCNiZNKFI8JBfUfQrFw6mcw',
  authDomain: 'centre-for-lung-care.firebaseapp.com',
  projectId: 'centre-for-lung-care',
  storageBucket: 'centre-for-lung-care.appspot.com',
  messagingSenderId: '1059921405310',
  appId: '1:1059921405310:web:583dbd9815f5e9bcd37f2f',
};

const app = getApps()?.length === 0 ? initializeApp(firebaseConfig) : getApp();
const auth = getAuth(app);

export { app, auth };
